export const setReschedulingStep = (inviteeId, step) => ({
  type: 'UPDATE_INVITEE',
  payload: {
    id: inviteeId,
    rescheduling: step
  }
})

export const rescheduleInvitee = (uuid, userUUID, bookingMethod, shareAttribution) => () => {
  const bookingMethodParam = bookingMethod ? `&booking_method=${bookingMethod}` : ''
  const shareAttributionParam = shareAttribution ? `&share_attribution=${shareAttribution}` : ''
  const baseUrl = `/reschedulings/${uuid}?&return_to=${window.location.pathname}${bookingMethodParam}${shareAttributionParam}`
  const url = userUUID ? `${baseUrl}&new_event_user_uuid=${userUUID}` : baseUrl

  window.location.assign(url)
}
